export const goblinIdle = new Image();
goblinIdle.src = "assets/characterSprites/goblin/Idle.png";
goblinIdle.width = 1200/8;
goblinIdle.height = 150/1;
goblinIdle.yOffset = 40
goblinIdle.xOffset = 100
goblinIdle.cycleLoop = [0, 0, 1, 1, 2, 2, 3, 3];